import './index.css';

import bannerImg from '../../assets/images/banner-image.png';

const index = () => {
  return (
    <div className='banner'>
      <div className='banner__desc'>
      <h1>
        The <span style={{ color: '#ffc800' }}>fastest and most complete</span>{' '}
        hospitality platform.
      </h1>
        <p>
        Turn on table service, pickup or delivery with a click of a button.
        </p>
        <button><a href="/#form">Sign up your venue</a></button>
        
      </div>
      <div className='banner__image'>
        <img src={bannerImg} alt={bannerImg} />
      </div>
    </div>
  );
};

export default index;
